import { render } from "./progress.vue?vue&type=template&id=5b23bd1e"
import script from "./progress.vue?vue&type=script&lang=js"
export * from "./progress.vue?vue&type=script&lang=js"

import "./progress.vue?vue&type=style&index=0&id=5b23bd1e&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/sign-log/advertising-register/step/components/progress.vue'],['render',render],['__file',"progress.vue"]])

export default __exports__